import { PayloadAction, createSlice       } from '@reduxjs/toolkit';

import { RootState                        } from 'src/store';
import Preferences                          from 'src/services/preferences';



const SLICE_NAME = 'main:attention-dialog';

export interface MainAttentionDialogState {
    isOpened: boolean;
    isChecked: boolean;
}

const initialState: MainAttentionDialogState = {
    isOpened: false,
    isChecked: false,
}

export const mainAttentionDialogSlice = createSlice({
    name: SLICE_NAME, 
    initialState: { ...initialState },
    reducers: {
        initDialog: (state, action: PayloadAction<boolean>) => {
            if (!Preferences.isVisibleAttantionProductCounter) {
                state.isOpened = action.payload
            } else {
                Preferences.setIsVisibleAttantionProductCounter((!action.payload).toString());
                state.isOpened = false
            }
        },
        setIsOpened: (state) => {
            if (Preferences.isVisibleAttantionProductCounter) {
                state.isOpened = !state.isOpened
            } else {
                state.isOpened = false
            }
        },
        setIsChecked: (state, action: PayloadAction<boolean>) => {
            Preferences.setIsVisibleAttantionProductCounter((!action.payload).toString());
            state.isChecked = action.payload
        }
    }
})

const selectIsOpened = (state: RootState) => state.mainAttentionDialog.isOpened;
const selectIsChecked = (state: RootState) => state.mainAttentionDialog.isChecked;

export const mainAttentionDialogSelectors = {
    selectIsOpened,
    selectIsChecked,
}

export const mainAttentionDialogActions = mainAttentionDialogSlice.actions;

export default mainAttentionDialogSlice.reducer;